import {NgModule, NO_ERRORS_SCHEMA} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';
import {MenuModule} from 'primeng/menu';
import {SliderModule} from 'primeng/slider';
import {InsparkMapModule} from './map/map.component';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {InsparkComponentsModule} from '@inspark/inspark-components/full';
import {XtermComponent} from './xterm/xterm.component';
import {SelectObjectTreeComponent} from './select-object-tree/select-object-tree.component';
import {PipesModule} from '../shared/pipes/pipes.module';
import {
  CanvasFormBuilderComponent
} from '../../../projects/common/modules/inspark-page-standard-forms/canvas-form-builder/canvas-form-builder.component';
import {RadioButtonModule} from 'primeng/radiobutton';
import {BreadcrumbModule} from 'primeng/breadcrumb';
import {TreeModule} from 'primeng/tree';
import {SharedModule} from '../shared/shared.module';
import {InlineSVGModule} from 'ng-inline-svg-2';

@NgModule({
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    InsparkComponentsModule,
    RadioButtonModule,
    TranslateModule.forRoot(), // Ломает локализацию если не рутом
    MenuModule,
    SliderModule,
    InsparkMapModule,
    NgbModule,
    InlineSVGModule.forRoot({baseUrl: 'assets/images/'}),
    BreadcrumbModule,
    TreeModule,
    SharedModule,
    PipesModule,
  ],
    exports: [
        InsparkComponentsModule,
        CanvasFormBuilderComponent
    ],
  declarations: [
    XtermComponent,
    SelectObjectTreeComponent,
    CanvasFormBuilderComponent
  ],
  schemas: [NO_ERRORS_SCHEMA]
})
export class ComponentsModule {
}
